import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { TrashIcon } from "../../../../ui/icons/trash";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import { FileInputComponent } from "../../../../ui/molecules/fileInput";
import { FileViewer } from "../../../../ui/molecules/fileViewer";
import { MadfarmInput } from "../../../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import TextArea from "../../../../ui/molecules/textArea";
import { OptionType } from "../../../../utils";
import { GetAllEntryProtocolAttachments, GetAllEntryProtocolObjects, resetGetAllEntryProtocolAttachmentsStatus, resetGetAllEntryProtocolObjectsStatus } from "../../../protocol/entry/slice";
import { DocumentCreation, DocumentValidation, GetAllDocuments, resetDocumentCreationRequest, resetDocumentCreationStatus, resetDocumentValidationStatus, setDocumentCreationDate, setDocumentCreationDetail, setDocumentCreationEntryAttachmentId, setDocumentCreationEntryObjectId, setDocumentCreationNote, setFileToUpload } from "../slice";

export function UploadedDocumentRightBarAdd() {
    const dispatch = useAppDispatch()
    const userState = useAppSelector(state => state.users)
    const documentState = useAppSelector(state => state.document)
    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const [objects, setObjects] = useState<OptionType[]>([])
    const [attachments, setAttachments] = useState<OptionType[]>([])

    let formData = new FormData()

    useEffect(() => {

        dispatch(GetAllEntryProtocolObjects())
        dispatch(GetAllEntryProtocolAttachments({
            itemsPerPage: 0,
            page: 0
        }))
    }, [])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolObjectsStatus === 'successfully' &&
            entryProtocolState.getAllEntryProtocolObjectsResponse !== undefined
        ) {
            dispatch(resetGetAllEntryProtocolObjectsStatus())
            const data = entryProtocolState.getAllEntryProtocolObjectsResponse
            const newObjects: OptionType[] = data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setObjects(newObjects)
        }
    }, [entryProtocolState.getAllEntryProtocolObjectsStatus])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolAttachmentsStatus === 'successfully' &&
            entryProtocolState.getAllEntryProtocolAttachmentsResponse !== undefined
        ) {
            dispatch(resetGetAllEntryProtocolAttachmentsStatus())
            const data = entryProtocolState.getAllEntryProtocolAttachmentsResponse
            const newAtts: OptionType[] = data.data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setAttachments(newAtts)
        }
    }, [entryProtocolState.getAllEntryProtocolAttachmentsStatus])

    useEffect(() => {
        if (documentState.documentValidationStatus === 'successfully') {
            dispatch(resetDocumentValidationStatus())
            formData.delete('file')
            formData.append('documentCreationDTO', JSON.stringify(documentState.documentCreationRequest))
            formData.append('file', documentState.fileToUpload!)
            dispatch(DocumentCreation(formData))
        }
    }, [documentState.documentValidationStatus])

    useEffect(() => {
        if (documentState.documentCreationStatus === 'successfully') {
            dispatch(resetDocumentCreationRequest())
            dispatch(resetDocumentCreationStatus())
            dispatch(setFileToUpload(undefined))
            dispatch(GetAllDocuments(documentState.getAllDocumentsFilters))
        }
    }, [documentState.documentCreationStatus])

    return (
        <div className="flex flex-col gap-5 w-full">
            <div className="flex justify-end">
                <ButtonComponent
                    color="orange"
                    variant="solid"
                    iconPosition="off"
                    size="md"
                    label="Aggiungi documento"
                    onClick={() => dispatch(DocumentValidation({
                        body: documentState.documentCreationRequest,
                        file: documentState.fileToUpload!
                    }))}
                />
            </div>

            <div className="border-t border-neutral-200" />
            <div className="grid grid-cols-1 gap-4">
                <div className="text-left flex flex-col gap-1">
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Dettaglio</span>
                    <MadfarmInput
                        placeholder="Specifica dettaglio"
                        supportingText={documentState.documentErrors.detail ? "Inserire la specifica del dettaglio" : undefined}
                        error={documentState.documentErrors.detail}
                        value={documentState.documentCreationRequest.detail}
                        defaultValue={documentState.documentCreationRequest.detail}
                        onChangeText={(text) => dispatch(setDocumentCreationDetail(text))}
                    />
                </div>

                <div className="text-left flex flex-col gap-1">
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Data</span>
                    <Calendar
                        selected={documentState.documentCreationRequest.date}
                        onChange={(date) => {
                            dispatch(setDocumentCreationDate(date))
                        }}
                    />
                </div>
            </div>

            <div className="border-t border-neutral-200" />
            <div className="grid grid-cols-1 gap-4">
                <div className="text-left flex flex-col gap-1">
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Oggetto</span>
                    <MadfarmStaticSelect
                        noOptionsMessage="Nessun risultato trovato"
                        value={documentState.documentCreationRequest.entryObjectId}
                        placeholder={'Seleziona...'}
                        options={objects}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setDocumentCreationEntryObjectId(newValue))
                        }}
                    />
                </div>
                <div className="text-left flex flex-col gap-1">
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Allegato</span>
                    <MadfarmStaticSelect
                        noOptionsMessage="Nessun risultato trovato"
                        value={documentState.documentCreationRequest.entryAttachmentId}
                        placeholder={'Seleziona...'}
                        options={attachments}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setDocumentCreationEntryAttachmentId(newValue))
                        }}
                    />
                </div>
            </div>

            <div className="border-t border-neutral-200" />
            <div className="text-left flex flex-col gap-1">
                <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Note</span>
                <TextArea onChangeText={(value) => dispatch(setDocumentCreationNote(value))} />
            </div>

            <div className="border-t border-neutral-200" />
            <div className="text-left flex flex-col gap-1">
                <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Allega file</span>
                <FileInputComponent
                    id={"ep-edit-upload-add"}
                    key={"ep-edit-upload-add"}
                    infoText
                    fullHeight
                    color={"green"}
                    onChange={(e) => {
                        dispatch(setFileToUpload(e[0]))
                    }}
                />
                {
                    documentState.fileToUpload && (
                        <div className="pt-3 flex items-center gap-3">
                            <div className="flex-1">
                                <FileViewer
                                    toUpdate
                                    fileName={documentState.fileToUpload.name}
                                    otherInfo={documentState.fileToUpload.type}
                                />
                            </div>
                            <button className="flex justify-center" onClick={() => dispatch(setFileToUpload(undefined))}>
                                <TrashIcon size={20} color="dimgrey" />
                            </button>
                        </div>
                    )
                }
            </div>
        </div>
    )
}